import router from "../../router";
import store from "../../store";

let menuConf = {
  groupItems: [
    {
      subheader: "none",
      items: [
        {
          name: "home",
          routeName: "home",
          icon: "fas fa-lg fa-tachometer-alt",
          iconType: "fa"
        }
      ]
    },
    {
      //GESTIONI PRATICHE
      subheader: "applicationManagementItems",
      items: [
        {
          name: "appointments",
          routeName: "_request-appointments",
          icon: "fas fa-lg fa-comment-medical",
          iconType: "fa"
        },
        {
          name: "appointmentsDone",
          routeName: "_booking-appointments",
          icon: "event_repeat",
          iconType: "md"
        },
        {
          name: "billsOfPaymentManagement",
          routeName: "_bills",
          icon: "file-circle-euro-solid.svg",
          iconType: "internal"
        },
        {
          name: "suspendedManagement",
          routeName: "_bills-sentback",
          icon: "fa-solid fa-file-pen",
          iconType: "fa"
        },
        {
          name: "payments",
          routeName: "_payments",
          icon: "fa-solid fa-euro-sign",
          iconType: "fa"
        },
        {
          name: "membersManagement",
          routeName: "membersManagement",
          icon: "assignment_ind",
          iconType: "fa"
        }
      ]
    },
    {
      //STRUMENTI DI AMMINISTRAZIONE
      subheader: "administrationToolsItems",
      items: [
        {
          name: "generalInfo",
          routeName: "_hfGeneralInfo",
          icon: "fa-solid fa-circle-info",
          iconType: "fa"
        },
        {
          name: "officeAdministration",
          routeName: "_officeAdministration",
          icon: "fas fa-lg fa-hospital",
          iconType: "fa"
        },
        {
          name: "operatorsManagement",
          routeName: "_operators",
          icon: "fas fa-lg fa-user-circle",
          iconType: "fa"
        }
      ]
    },
    {
      //COMUNICA CON FONDO EST
      subheader: "communicationItems",
      items: [
        {
          name: "notifications",
          routeName: "_notificationsCenter",
          icon: "fas fa-lg fa-bell",
          iconType: "fa"
        },
        {
          name: "contact",
          routeName: "contact",
          icon: "fas fa-lg fa-tablet-alt",
          iconType: "fa"
        }
      ]
    }
  ]
};

menuConf.groupItems.forEach(groupItem => {
  groupItem.items.forEach(item => {
    let routeName = item.routeName;
    item.action = isSameRoute => {
      if (!isSameRoute) firstLevelAction(routeName);
    };
  });
});

async function firstLevelAction(routeNameToGo) {
  if (routeNameToGo === "_request-appointments") {
    store.commit("appointments/udpateAcceptedToWork", null, null, {
      root: true
    });
    store.commit("appointments/SET_MULTI_SELECT_ACTIVE_LIST", [], null, {
      root: true
    });
  }
  if (routeNameToGo === "_bills") {
    store.commit("bills/SET_MULTI_SELECT_FULL_LIST", false, null, {
      root: true
    });
    store.commit(`bills/SET_MULTI_SELECT_ACTIVE_LIST`, [], null, {
      root: true
    });
  }
  if (routeNameToGo === "_bills-sentback") {
    store.commit("bills/SET_MULTI_SELECT_FULL_LIST", true, null, {
      root: true
    });
    store.commit(`bills/SET_MULTI_SELECT_ACTIVE_LIST`, [], null, {
      root: true
    });
  }
  let r = await store.dispatch(
    "notifications/getNotificationsUnreadCount",
    null,
    {
      root: true
    }
  );
  if (r >= 0) {
    router
      .push({
        name: routeNameToGo
      })
      .catch(error => console.log(error));
  }
}

export default menuConf;
